import { create } from 'zustand';
import { reportsAPI } from '../api/services';

const useReportStore = create((set) => ({
  reports: [],
  report: null,
  loading: false,
  error: null,
  pagination: { current: 1, pageSize: 15, total: 0 },

  fetchReports: async (params = {}) => {
    set({ loading: true });
    try {
      const res = await reportsAPI.getAll(params);
      const data = res.data?.data || res.data;
      set({
        reports: Array.isArray(data) ? data : data?.data || [],
        pagination: {
          current: data?.current_page || 1,
          pageSize: data?.per_page || 15,
          total: data?.total || 0,
        },
        loading: false,
      });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  fetchReport: async (id) => {
    set({ loading: true });
    try {
      const res = await reportsAPI.getOne(id);
      set({ report: res.data?.data || res.data, loading: false });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  updateReportStatus: async (id, data) => {
    const res = await reportsAPI.updateStatus(id, data);
    return res.data;
  },

  deleteReport: async (id) => {
    await reportsAPI.delete(id);
  },
}));

export default useReportStore;
